import { render, staticRenderFns } from "./FlowDetails.vue?vue&type=template&id=6da86f37&scoped=true"
import script from "./FlowDetails.vue?vue&type=script&lang=js"
export * from "./FlowDetails.vue?vue&type=script&lang=js"
import style0 from "./FlowDetails.vue?vue&type=style&index=0&id=6da86f37&prod&scoped=true&lang=css"
import style1 from "./FlowDetails.vue?vue&type=style&index=1&id=6da86f37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da86f37",
  null
  
)

export default component.exports